module.exports = __webpack_public_path__ + "img/logoAIPassIntelite.c7bdeff4.png";